

import { Button } from "@a2z/ui";

import { useState } from "react";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { Locale } from "@/lib/i18n/config";
import { StoreCreateForm } from "./StoreCreateForm";

type Props = {
  sellerId: string;
  locale: Locale;
  plans: { id: string; nameAr: string; nameEn: string | null }[];
};

export function StoreCreateModal({ sellerId, locale, plans }: Props) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSuccess = () => {
    setIsOpen(false);
  };

  if (!isOpen) {
    return (
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        variant="primary" className="h-10 rounded-lg px-4 text-sm font-semibold"
      >
        {t(keys.admin.createStoreAction)}
      </Button>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 pt-10 pb-[max(2.5rem,env(safe-area-inset-bottom))]">
      <div className="max-h-full w-full max-w-2xl overflow-y-auto rounded-2xl bg-[color:var(--surface)] p-6 shadow-[var(--shadow-md)]">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)]">
              {t(keys.admin.createStoreTitle)}
            </h2>
            <p className="mt-1 text-xs text-[color:var(--text-muted)]">
              {t(keys.admin.createStoreSubtitle)}
            </p>
          </div>
          <Button variant="ghost"
            type="button"
            onClick={closeModal}
            className="text-xs font-semibold text-[color:var(--text-muted)]"
          >
            {t(keys.common.close)}
          </Button>
        </div>
        <div className="mt-6">
          <StoreCreateForm
            sellerId={sellerId}
            locale={locale}
            plans={plans}
            onSuccess={handleSuccess}
          />
        </div>
      </div>
    </div>
  );
}
